module.exports = __webpack_public_path__ + "img/GHS-pictogram-acid.9cab2d54.png";